"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateProduct = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Raven = _interopRequireDefault(require("Raven"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _activateByProduct = require("ui-addon-upgrades/_core/common/api/activateByProduct");

var _productActivation = require("ui-addon-upgrades/_core/common/constants/productActivation");

var _auth = require("hub-http/auth");

var activateProduct = function activateProduct(upgradeData) {
  var upgradeProduct = upgradeData.upgradeProduct;
  var activationType = _productActivation.upgradeProductToActivationType[upgradeProduct];
  return (0, _activateByProduct.activateByProduct)(activationType).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('productActivationInteraction', (0, _extends2.default)({
      action: 'activation succeeded'
    }, upgradeData));
  }).then(function () {
    return (0, _auth.refreshCookie)(_PortalIdParser.default.get(), true);
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('productActivationInteraction', (0, _extends2.default)({
      action: 'activation failed'
    }, upgradeData));

    _devLogger.default.warn({
      message: e,
      key: 'ProductActivationButton'
    });

    _Raven.default.captureMessage('Product activation failed', {
      extra: {
        error: e
      }
    });

    return Error();
  });
};

exports.activateProduct = activateProduct;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/productActivation/activateProduct.js
// module id = 770
// module chunks = 5 6